import Head from 'next/head'
import shopInfos from 'template/infos'
const { name, url } = shopInfos

const Seo: React.FC = () => <Head>

  <title>{`Zahlung und Versand bei ${name}`}</title>

  <meta name='description' content={`
    Informationen zu Zahlungsarten, DHL-Paketversand, Speditionslieferungen
    und Auslandsversand bei ${name}.
  `} />

  <link rel='canonical' href={`${url}zahlung-und-versand`} />

</Head>

export default Seo
